import api from 'api';
import UsersTable from 'components/UsersTable/UsersTable';
import { IUsers } from 'interfaces';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { fetchUserPermissions } from 'store/reducers/userDataCreator';
import fetchGroupsAndUsers, { defaultGroups, fetchPermissions, setNewRole } from 'store/reducers/usersGroupCreator';
import { setDocuments } from 'store/slices/dataDocumentsSlice';
import { setPendingInviteUsers, setUserChoosen } from 'store/slices/dataUsersSlice';
import { setIsRSidebarCollapsed, setSelectedKeys } from 'store/slices/windowStateSlice';

const Users = () => {
  const { users, pendingInviteUsers, groups, rolesPermissions } = useAppSelector((store) => store.dataUsers);
  const { dataRoom, isLoadingRoom } = useAppSelector((store) => store.dataRoom);
  const { rSidebarEntity, messageApi } = useAppSelector((store) => store.windowState);
  const { userData } = useAppSelector((store) => store.userData);

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    !rolesPermissions[0] && dispatch(fetchPermissions({ t }));
  }, [i18n.language]);

  React.useEffect(() => {    
    rSidebarEntity !== 'user_data' && dispatch(setUserChoosen(null));
  },[rSidebarEntity]);
  
  React.useEffect(() => {
    dispatch(setSelectedKeys(['users']));
    dispatch(setDocuments({documents: [], folders: []}));
    dataRoom && !users[0] && dispatch(fetchGroupsAndUsers({ room_id: dataRoom?.id }));

    return () => {
      dispatch(setUserChoosen(null));
      dispatch(setIsRSidebarCollapsed({collapsed: true, entity: '', width: 0}));
    };
  }, [dataRoom?.id]);

  const changeRole = async (user: IUsers, group_id: string) => {
    const groupName = groups.find((group) => group.id === group_id)?.name;
    const localizedRoleName =
      groupName && defaultGroups.includes(groupName) ? t(`Users.table.${groupName}`) : groupName;
      
      if (user.type === 'invite') {
      try {
        await api.changeInviteRole({invite_id: user?.id, group_id, role_name: groupName || ''})
        dispatch(setPendingInviteUsers(pendingInviteUsers.map(invite => invite.id === user.id
          ? {...invite, group_id}
          : invite
        )));
        messageApi?.success(`${t('Users.success.addInviteUser')} '${localizedRoleName}'`);
      } catch (e) {
        messageApi?.error(`${t('Users.error.addInviteUser')} '${localizedRoleName}'`);
      };
    } else {
      const prevgGoupName = groups.find((group) => group.id === user?.group[0])?.name;
      const details = {
        username: user?.first_name,
        group_name: groupName,
        prev_group_name: prevgGoupName,
      };
      const responce = await dispatch(setNewRole({ user, group_id, room_id: dataRoom?.id!, details, t }));
  
      if (user.id === userData?.id) dataRoom && await dispatch(fetchUserPermissions({ idRoom: dataRoom.id }));
  
      responce?.payload === 'Failed setting new role'
        ? messageApi?.error(`${t('Users.error.addUser')} '${localizedRoleName}'`)
        : messageApi?.success(`${t('Users.success.addUser')} '${localizedRoleName}'`);
    };
  };

  return (
    <div>
      <UsersTable
        changeRole={changeRole}
        isLoadingRooms={isLoadingRoom}
      />
    </div>
  );
}

export default Users;

